import { Group, Label } from '@radix-ui/react-select';
import type { ReactNode } from 'react';
import { styled } from 'styled-components';
import { Heading } from '../Heading';

export type SelectOptionGroupProps = {
  /** The label of the group */
  label: string;
  /** At least one `Option` */
  children: ReactNode;
};

const StyledLabel = styled(Label)`
  padding: var(--wui-select-option-padding);
`;

export const SelectOptionGroup = ({ children, label, ...props }: SelectOptionGroupProps) => {
  return (
    <Group {...props}>
      <StyledLabel>
        <Heading
          renderAs="span"
          variant="heading6"
        >
          {label}
        </Heading>
      </StyledLabel>
      {children}
    </Group>
  );
};
